/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Addr_Sugg_HintInputs */

const cs_addr_sugg_hint = /** @type {(inputs: Addr_Sugg_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chybějící části adresy dohledané v RÚIAN. Nic se nepoužije samo; přijatá hodnota se uloží jako ruční úprava a import ji nepřepíše.`)
};

const en_addr_sugg_hint = /** @type {(inputs: Addr_Sugg_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Missing address parts looked up in RÚIAN. Nothing is applied automatically; an accepted value is saved as a manual edit and imports won't overwrite it.`)
};

/**
* | output |
* | --- |
* | "Missing address parts looked up in RÚIAN. Nothing is applied automatically; an accepted value is saved as a manual edit and imports won't overwrite it." |
*
* @param {Addr_Sugg_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const addr_sugg_hint = /** @type {((inputs?: Addr_Sugg_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Addr_Sugg_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_addr_sugg_hint(inputs)
	return cs_addr_sugg_hint(inputs)
});